import { Checkbox } from "@/components/ui/checkbox";
import { Label } from '@/components/ui/label';

interface CampaignScheduleProps {
  schedule: string[];
  onChange: (schedule: string[]) => void;
}

const DAYS = [
  { id: 'monday', label: 'Monday' },
  { id: 'tuesday', label: 'Tuesday' },
  { id: 'wednesday', label: 'Wednesday' },
  { id: 'thursday', label: 'Thursday' },
  { id: 'friday', label: 'Friday' },
  { id: 'saturday', label: 'Saturday' },
  { id: 'sunday', label: 'Sunday' },
];

export function CampaignSchedule({ schedule, onChange }: CampaignScheduleProps) {
  const toggleDay = (day: string) => {
    const newSelection = schedule.includes(day)
      ? schedule.filter(d => d !== day)
      : [...schedule, day];
    onChange(newSelection);
  };

  return (
    <div className="space-y-4">
      <div className="grid gap-4 sm:grid-cols-2">
        {DAYS.map((day) => (
          <div key={day.id} className="flex items-center space-x-3">
            <Checkbox
              id={day.id}
              checked={schedule.includes(day.id)}
              onCheckedChange={() => toggleDay(day.id)}
            />
            <Label
              htmlFor={day.id}
              className="text-sm font-normal leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
            >
              {day.label}
            </Label>
          </div>
        ))}
      </div>
      <p className="text-sm text-muted-foreground">
        Select the days of the week when emails from this campaign can be sent.
      </p>
    </div>
  );
}